import { Component } from "@angular/core";
import { AgFilterComponent } from "@ag-grid-community/angular";
import { IDoesFilterPassParams, IFilterParams } from "@ag-grid-community/core";
import { LogService } from "src/app/services/log.service";
import { ConfirmationDialogService } from "src/app/modules/confirmation-dialog/confirmation-dialog.service";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "global-search-filter",
  templateUrl: "./global-search-filter.component.html",
  styleUrls: ["./global-search-filter.component.css"],
})
export class GlobalSearchFilterComponent implements AgFilterComponent {
  params: IFilterParams;
  filter: string = "";
  filterType: number = 0;
  _isFilterActive: boolean = false;

  /**
   *
   */
  constructor(
    private confirmationDialogService: ConfirmationDialogService,
    public translate: TranslateService,
    private logger: LogService
  ) {}

  agInit(params: IFilterParams): void {
    this.logger.log("GTS Filter Params are:", params);
    this.params = params;
  }

  isFilterActive(): boolean {
    return this._isFilterActive;
  }

  doesFilterPass(params: IDoesFilterPassParams): boolean {
    return true;
  }

  getModel() {
    return this._isFilterActive
      ? {
          filter: this.filter,
          filterType: this.filterType,
          type: "gts",
        }
      : null;
  }

  setModel(model: any) {
    if (!model) return;

    this.filter = model.filter;
    this.filterType = model.filterType;
    this._isFilterActive = true;
    this.setOtherFilterPanelVisiblity(false);
  }

  updateFilter() {
    this.logger.log("GTS - updateFilter()");
    this.params.filterChangedCallback();
  }

  applyFilterClicked() {
    this.confirmationDialogService
      .showGlobalTankSearchDialog()
      .subscribe((result) => {
        if (result) {
          this.applyFilter();
        }
      });
  }

  applyFilter() {
    this._isFilterActive = true;
    this.updateFilter();
    this.setOtherFilterPanelVisiblity(false);
  }

  setOtherFilterPanelVisiblity(showPanel: boolean) {
    let filterToolPanel: any = this.params.api.getToolPanelInstance("filters");

    filterToolPanel.filtersToolPanelListPanel.filterGroupComps.forEach(
      (element, index) => {
        if (index === 0) return;
        element.setVisible(showPanel);
      }
    );
  }

  clearFilter() {
    this.filterType = 0;
    this.filter = "";
    this._isFilterActive = false;
    this.updateFilter();
    this.setOtherFilterPanelVisiblity(true);
  }

  disableClear(): boolean {
    return !this._isFilterActive;
  }

  disableApply(): boolean {
    return this.filter.length < 3;
  }
}
